<script setup lang="ts">
import VModernSelect from "@verbleif/lib/src/components/AutoComplete/VModernSelect.vue";
import { englishSecondaryName } from "@verbleif/lib/src/components/LocaleSelect/locale";
import VLocaleOption from "@verbleif/lib/src/components/LocaleSelect/VLocaleOption.vue";
import { useI18n } from "@verbleif/lib/src/translations/i18n";
import NavbarSettingsItem from "../NavbarSettingsItem.vue";
import { useNavbarLocale } from "./useNavbarLocale";

const { t } = useI18n();
const { languageOptions, locale } = useNavbarLocale();
const TRANSLATION_KEY = "navbar.dropdown";
</script>

<template>
  <VModernSelect
    v-model="locale"
    :items="languageOptions"
    placement="left"
    :auto-size="false"
    key-field-name="value"
    search-field-name="label"
    :search-also-field-names="['englishName']"
  >
    <template #input="{ show }">
      <button
        type="button"
        class="custom-input-wrapper block w-full text-left focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:outline-hidden focus-visible:ring-inset"
        @click="show"
      >
        <NavbarSettingsItem icon="languages" :text="t(`${TRANSLATION_KEY}.change_language`)" />
      </button>
    </template>
    <template #item="{ item, label, highlight }">
      <VLocaleOption
        :locale="item.value"
        :name="item.label"
        :flag-src="`/flags/${item.value.toUpperCase()}.svg`"
        :secondary="englishSecondaryName(item.value, item.label)"
        :label="label"
        :highlight="highlight"
      />
    </template>
  </VModernSelect>
</template>
